import { render, staticRenderFns } from "./resources.page.vue?vue&type=template&id=35c8b375&"
import script from "./resources.page.vue?vue&type=script&lang=ts&"
export * from "./resources.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports